import { render } from "./cell_custom1.vue?vue&type=template&id=40aca497"
import script from "./cell_custom1.vue?vue&type=script&lang=ts"
export * from "./cell_custom1.vue?vue&type=script&lang=ts"
script.render = render

export default script